import React, { Fragment, useEffect, useState } from "react";
import { Row, Button } from "reactstrap";
import { Colxx } from "../../../components/shared/CustomBootstrap";
import { Card, CardBody, Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchPaymentInfo } from "../../../redux/action";
import sliderCloseIcon from "../../../assets/images/slider-close-icon.svg";
import {
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_KEY, SUPPORT_PHONE_RAW } from "../../../constants/defaultValues";
import {formatPhoneNumber} from "react-phone-number-input";
import CheckoutForm from "../../../components/Settings/Payments/CheckoutForm";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Collapse,
  Col,
} from "reactstrap";

const stripePromise = loadStripe(STRIPE_KEY);

export default function Payments() {
  const paymentDetails = useSelector((state) => state.settings.payment_details);
  const dispatch = useDispatch();
  const [paymentsModal, setPaymentsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const changeLoadingStatus = () => {
    setIsLoading(false);
  };

  const getPaymentInfo = () => {
    dispatch(fetchPaymentInfo());
  };

  const customToggle = () => {
    setPaymentsModal(!paymentsModal);
  };

  useEffect(() => {
    getPaymentInfo();
  }, []);
  return (
    <>
      <div className="main-section-scroll-height">
        <Fragment>
          <Modal isOpen={paymentsModal} toggle={customToggle}>
            <ModalHeader toggle={customToggle}>Add payment method</ModalHeader>

            <ModalBody>
              <Row>
                <Elements stripe={stripePromise}>
                  <CheckoutForm changeLoadingStatus={changeLoadingStatus} />
                </Elements>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={customToggle}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>

          <Row>
            <Colxx xxs="12">
              <Card className="payment-first-box">
                <CardBody>
                  <p>
                    Your subscription status is{" "}
                    {paymentDetails &&
                    paymentDetails.subscription_status &&
                    paymentDetails.subscription_status !== "exsisting"
                      ? paymentDetails.subscription_status
                      : "New"}
                  </p>
                  <p>Current Plan: {paymentDetails?.plan}</p>

                  {paymentDetails.plan == "None" ? (
                    <p>
                      {" "}
                      Please contact INCA support to add your payment plan{" "}
                    </p>
                  ) : !paymentDetails.subscription_status ||
                    paymentDetails.subscription_status == "exsisting" ? (
                    <>
                      <p>
                        Setup Fee:{" "}
                        {paymentDetails.setup_fee
                          ? paymentDetails.setup_fee
                          : 0}{" "}
                        USD
                      </p>
                      <p>
                        Please add a payment method to activate your
                        personalized portal. If you need any assistance please
                        email us at info@getinca.com or call us at <a href={`tel:${SUPPORT_PHONE_RAW}`}>{formatPhoneNumber(SUPPORT_PHONE_RAW)}</a>. Thank you!
                      </p>
                    </>
                  ) : !paymentDetails.subscription_status ||
                    [
                      "incomplete_expired",
                      "past_due",
                      "canceled",
                      "unpaid",
                      "expired",
                    ].indexOf(paymentDetails.subscription_status) != -1 ? (
                    <>
                      <p>
                        Your monthly fee is pending because your previous
                        subscription is cancelled! Please add a new payment
                        method to continue. If you need any assistance please
                        email us at info@getinca.com or call us at {" "}
                        <a href={`tel:${SUPPORT_PHONE_RAW}`}>{formatPhoneNumber(SUPPORT_PHONE_RAW)}</a>. Thank you!
                      </p>
                    </>
                  ) : (
                    <p>
                      {" "}
                      Please download the INCA app from the App Store or Google
                      Play Store in order to use INCA on your mobile device.
                      Thank you!
                    </p>
                  )}
                </CardBody>
              </Card>
            </Colxx>
          </Row>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <h1 className="filters mt-4">Payment Methods</h1>
            <button
              onClick={customToggle}
              className="secondary-btn"
              data-bs-toggle="offcanvas"
              data-bs-target=""
              style={{ height: "40px" }}
            >
              Add Payment Method
            </button>
          </div>

          <table className="mt-2 table table-borderless">
            <thead>
              <tr>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Last 4
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Brand
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Country
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Expiry Date
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {paymentDetails &&
                paymentDetails.paymentMethods &&
                paymentDetails.paymentMethods.length < 1 && (
                  <tr>
                    <td className="align-middle" colSpan={5}>
                      Updating (Nothing to Show)
                    </td>
                  </tr>
                )}

              {paymentDetails &&
                paymentDetails.paymentMethods &&
                paymentDetails.paymentMethods.length > 0 &&
                paymentDetails.paymentMethods.map((method) => (
                  <tr>
                    <td className="align-middle">{method.last4}</td>
                    <td className="align-middle">{method.brand}</td>
                    <td className="align-middle">{method.country}</td>
                    <td className="align-middle">{method.expiry}</td>
                    <td className="align-middle">
                      {paymentDetails?.defaultPaymentMethod == method.id ? (
                        "primary"
                      ) : (
                        <>
                          <Button className="btn-xs" color="primary">
                            Set as primary
                          </Button>
                          <Button className="btn-xs" color="danger">
                            Delete
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <h1 className="filters mt-4">Upcoming Payments</h1>

          <table className="mt-2 table table-borderless">
            <thead>
              <tr>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Amount
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Status
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Current Expiry Date
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Will be Charge
                </th>
              </tr>
            </thead>
            <tbody>
              {paymentDetails &&
              paymentDetails.upcomingPayments &&
              paymentDetails.upcomingPayments.length < 1 ? (
                <tr>
                  <td className="align-middle" colSpan={5}>
                    Updating (Nothing to Show)
                  </td>
                </tr>
              ) : (
                paymentDetails &&
                paymentDetails.upcomingPayments &&
                paymentDetails.upcomingPayments.map((payment, index) => (
                  <tr key={index}>
                    <td className="align-middle">${payment.amount}</td>
                    <td className="align-middle">{payment.status}</td>
                    <td className="align-middle">{payment.period_end}</td>
                    <td className="align-middle">{payment.created}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center mt-4">
            <h1 className="filters mt-4">Payment History</h1>
          </div>

          <table className="mt-2 table table-borderless">
            <thead>
              <tr>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Amount
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Description
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Status
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Receipt URL
                </th>
                <th
                  className="align-middle"
                  style={{ width: "20%" }}
                  scope="col"
                >
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {paymentDetails &&
              paymentDetails.paymentsHistory &&
              paymentDetails.paymentsHistory.length < 1 ? (
                <tr>
                  <td className="align-middle" colSpan={5}>
                    Updating (Nothing to Show)
                  </td>
                </tr>
              ) : (
                paymentDetails &&
                paymentDetails.paymentsHistory &&
                paymentDetails.paymentsHistory.map((payment, index) => (
                  <tr key={index}>
                    <td className="align-middle">${payment.amount}</td>
                    <td className="align-middle">{payment.description}</td>
                    <td className="align-middle">{payment.status}</td>
                    <td className="align-middle">
                      <a target="_blank" href={payment.receipt_url}>
                        link
                      </a>
                    </td>
                    <td className="align-middle">{payment.created}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Fragment>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="createContactCanvas"
        aria-labelledby="createContactCanvasLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="createContactCanvasLabel">
            Add Payment Method
          </h5>
          <button
            type="button"
            className="slider-close-btn"
            data-bs-dismiss="offcanvas"
          >
            <img src={sliderCloseIcon} className="img-fluid" />
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="tags mb-3">
            <input
              type="text"
              name="cardnumber"
              className="form-control slider-inputs"
              placeholder="Enter Card Number"
            />
          </div>

          <div className="d-flex justify-content-between">
            <div className="tags mb-3 w-10 ">
              <input
                type="text"
                name="date"
                className="form-control slider-inputs"
                placeholder="MM/YY"
              />
            </div>
            <div className="tags extra mb-4.5 mx-4">
              <input
                type="text"
                name="cvc"
                className="form-control slider-inputs"
                placeholder="CVC"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              className="slider-cancel-btn me-2"
              data-bs-dismiss="offcanvas"
            >
              Cancel
            </button>
            <button className="slider-success-btn" data-bs-dismiss="offcanvas">
              Add
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
